import {
    REQUEST_DATA_STRUCTURE,
    RECEIVE_DATA_STRUCTURE,
    ERROR_DATA_STRUCTURE
} from '../types'
import {initialFetchState} from "../../constants/defaultValues"
import _get from "lodash/get"
import _cloneDeep from 'lodash/cloneDeep'

const s = {}

export default (state = s, action = {}) => {
    const newState = _cloneDeep(state)

    switch(action.type) {
        case REQUEST_DATA_STRUCTURE:
            newState[action.identifier] = {
                ...initialFetchState,
                data: _get(newState, [action.identifier, 'data'], {}),
                isFetching: true
            }
            return newState
        case RECEIVE_DATA_STRUCTURE:
            newState[action.identifier] = {
                ...newState[action.identifier],
                isFetching: false,
                data: action.payload,
                message: '',
                errors: {}
            }
            return newState
        case ERROR_DATA_STRUCTURE:
            newState[action.identifier] = {
                ...newState[action.identifier],
                isFetching: false,
                data: {},
                message: action.errors.server || '',
                errors: action.errors
            }
            return newState
        default:
            return state
    }
}